/* istanbul ignore file */
import { be, de, enGB, es, fr, it, pt } from 'date-fns/locale';

export const getLocale = (lang: string) => {
  switch (lang) {
    case 'be':
      return be;
    case 'de':
      return de;
    case 'enGB':
      return enGB;
    case 'es':
      return es;
    case 'fr':
      return fr;
    case 'it':
      return it;
    case 'pt':
      return pt;
    default:
      return fr;
  }
};
